import React from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";
import {
  Upload as UploadIcon,
  Assessment as AssessmentIcon,
  Block as BlockIcon,
  Sync as SyncIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { Layout } from "../components/Layout";
import { useAuth } from "../context/AuthContext";

const UtilitiesPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <Layout>
      <Box>
        <Typography variant='h4' gutterBottom>
          Utilities & Tools
        </Typography>

        <Card
          sx={{
            mb: 3,
            borderLeft: "8px solid",
            borderLeftColor: "success.main",
            cursor: "pointer",
            transition: "all 0.3s ease",
            "&:hover": {
              transform: "translateY(-2px)",
              boxShadow: 4,
            },
          }}
          onClick={() => navigate("/utilities/active-patients")}
        >
          <CardContent>
            <Typography variant='h5' gutterBottom color='success.main'>
              <AssessmentIcon sx={{ mr: 1, verticalAlign: "middle" }} />
              Active Patients Report
            </Typography>
            <Typography variant='body2' color='text.secondary'>
              View and export active patients from CCM (partnering system) with
              member details. Supports Excel export for White Plains Health,
              Pinnacle Rx Solutions, and Valley Healthcare.
            </Typography>
          </CardContent>
        </Card>

        {user?.roleID === 10 && (
          <Card
            sx={{
              mb: 3,
              borderLeft: "8px solid",
              borderLeftColor: "primary.main",
              cursor: "pointer",
              transition: "all 0.3s ease",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: 4,
              },
            }}
            onClick={() => navigate("/admin/patient-import")}
          >
            <CardContent>
              <Typography variant='h5' gutterBottom color='primary'>
                <UploadIcon sx={{ mr: 1, verticalAlign: "middle" }} />
                Patient Enrollments
              </Typography>
              <Typography variant='body2' color='text.secondary'>
                Enrollment import utility with Excel file support, client
                selection, program enrollment, and automatic integration with
                partner systems. Administrator access only.
              </Typography>
            </CardContent>
          </Card>
        )}

        {user?.roleID === 10 && (
          <Card
            sx={{
              mb: 3,
              borderLeft: "8px solid",
              borderLeftColor: "error.main",
              cursor: "pointer",
              transition: "all 0.3s ease",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: 4,
              },
            }}
            onClick={() => navigate("/admin/supply-holds")}
          >
            <CardContent>
              <Typography variant='h5' gutterBottom color='error'>
                <BlockIcon sx={{ mr: 1, verticalAlign: "middle" }} />
                Patient Supply Holds
              </Typography>
              <Typography variant='body2' color='text.secondary'>
                Manage patients with supply holds. View all active holds,
                release dates, and add or remove hold status. Administrator
                access only.
              </Typography>
            </CardContent>
          </Card>
        )}

        {user?.roleID === 10 && (
          <Card
            sx={{
              mb: 3,
              borderLeft: "8px solid",
              borderLeftColor: "info.main",
              cursor: "pointer",
              transition: "all 0.3s ease",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: 4,
              },
            }}
            onClick={() => navigate("/admin/patient-reconciliation")}
          >
            <CardContent>
              <Typography variant='h5' gutterBottom color='info.main'>
                <SyncIcon sx={{ mr: 1, verticalAlign: "middle" }} />
                Patient Reconciliation
              </Typography>
              <Typography variant='body2' color='text.secondary'>
                Reconcile patients between TNS and CCM systems. Automatically
                stores CCM patient IDs for matched patients and identifies
                mismatches. Administrator access only.
              </Typography>
            </CardContent>
          </Card>
        )}
      </Box>
    </Layout>
  );
};

export default UtilitiesPage;
